// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { activeSkin } from './skin';

/** The font families of the active skin, by role. Values live in theme/skins/<name>.ts. */
export const appFonts = activeSkin.fonts;

export default appFonts;
